// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"3d3e9065","186":"edfac6e3","228":"c4cc1425","331":"b014d84b","339":"31e1a530","362":"6d3cdd42","442":"71198dea","446":"a6ed2fd0","672":"4c09b3ef","678":"bac234d6","778":"9680207d","791":"3dbdb8d7","805":"02962a24","886":"915ad1ef"}[chunkId] + ".chunk.js";
};